// Libraries
import {
  Component,
  Input
} from '@angular/core';

// Models
import {
  Extinguisher,
  EXTINGUISHER_STATUSES
} from '../models';

/**
 * `ExtinguisherStatusComponent` implements a view to show the status of a extinguisher.
 */
@Component({
  selector: 'she-extinguisher-status',
  template: `<span class="she-status she-status-{{extinguisher?.status}}">{{getStatus()}}</span>`
})
export class ExtinguisherStatusComponent {
  /**
   * Current extinguisher.
   */
  @Input() extinguisher: Extinguisher;

  /**
   * Creates a new `ExtinguisherStatusComponent` instance.
   */
  constructor() {}

  /**
   * Returns the status of current extinguisher.
   * @return extinguisher status
   */
  public getStatus(): string {
    return this.extinguisher ? EXTINGUISHER_STATUSES[this.extinguisher.status] : '';
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/admin/shared/components/extinguisher-status.component.ts